import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { getCurrentInstance, reactive, ref } from 'vue';
import apis from "@/api";
import _ from 'lodash';
import { genFileId } from 'element-plus';
export default {
  __name: 'HelpUpload',
  props: {
    title: {
      type: String,
      default: '文件上传',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    fileTypes: {
      type: Array,
      default: () => {
        return ['image/jpeg', 'image/png', 'image/gif'];
      },
      required: false
    },
    fileSize: {
      type: Number,
      default: 10,
      //单位MB
      required: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    vaildImgType: {
      type: Boolean,
      default: false
    }
  },
  emits: ['success', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const props = __props;
    const emits = __emit;
    const data = reactive({
      fileList: []
    });
    const fileLoading = ref(false);
    const fileNames = ref("");
    const fileModalForm = reactive({
      fileName: ""
    });
    const rulesValue = reactive({
      fileName: [{
        required: true,
        message: "文件名称不能为空!",
        trigger: "change"
      }]
    });
    const submitUpload = () => {
      if (!data.fileList || data.fileList.length == 0) {
        ElMessage.error('请先选取文件');
        return;
      }
      proxy.$refs["fileForm"].validate(valid => {
        if (valid) {
          fileLoading.value = true;
          let formData = new FormData();
          data.fileList.forEach(f => {
            formData.append('fileList', f);
          });
          formData.append('bucketName', 'outer-for-inner');
          apis.upload(formData).then(res => {
            console.log("upload-res: ", res);
            let param = {
              'fileNewName': fileModalForm.fileName
            };
            if (res && res.success) {
              param.files = res.data;
              emits('uploadSuccess', param);
            } else {
              ElMessage.error('文件上传失败:' + res.msg);
            }
            fileLoading.value = false;
          }).catch(err => {
            console.log("err", err);
            ElMessage.error('文件上传失败');
            fileLoading.value = false;
          });
        } else {
          ElMessage.error('文件名称不能为空!');
          return;
        }
      });
    };
    const uploadFiles = params => {
      data.fileList.push(params.file);
    };
    const handleExceed = params => {
      data.fileList = [];
      params[0].uid = genFileId();
      data.fileList.push(params[0]);
    };
    const beforeUpload = rawFile => {
      if (props.vaildImgType) {
        const index = _.findIndex(props.fileTypes, type => {
          return type === rawFile.type;
        });
        if (index === -1) {
          ElMessage.error('文件类型不支持:' + rawFile.type);
          return false;
        }
        if (rawFile.size / 1024 / 1024 > props.fileSize) {
          ElMessage.error('文件大小超出限制');
          return false;
        }
      }
      return true;
    };
    const close = () => {
      data.fileList = [];
      emits('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        width: "30%",
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-position": "left",
          ref: "fileForm",
          model: fileModalForm,
          rules: rulesValue
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "文件名称",
            prop: "fileName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 10
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "请输入文件名称",
                modelValue: fileModalForm.fileName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => fileModalForm.fileName = $event),
                clearable: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"]), _createVNode(_component_el_upload, {
          multiple: __props.multiple,
          "http-request": uploadFiles,
          limit: 1,
          "file-list": data.fileList,
          "before-upload": beforeUpload,
          "on-exceed": handleExceed
        }, {
          trigger: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("上传附件", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "btn-right",
            type: "success",
            onClick: submitUpload,
            loading: fileLoading.value
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("上传", -1)]))]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        }, 8, ["multiple", "file-list"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};